import type { TTSGender, TTSLanguage, TTSLanguageCode } from "./types";

export const getVoice = (language: TTSLanguage, gender: Exclude<TTSGender, "both">) => {
	const data: Record<
		TTSLanguage,
		Record<
			Exclude<TTSGender, "both">,
			{ name: string; code: string; photo: string; languageCode: TTSLanguageCode; sample: string }
		>
	> = {
		cs: {
			male: {
				languageCode: "cs-CZ",
				code: "ai3-cs-CZ-Antonin",
				name: "Antonín",
				photo: "/faces/cs-CZ/ai3-cs-CZ-Antonin.webp",
				sample: "/voice_samples/ai3-cs-CZ-Antonin.mp3",
			},
			female: {
				languageCode: "cs-CZ",
				code: "ai2-cs-CZ-Eliska",
				name: "Eliška",
				photo: "/faces/cs-CZ/ai2-cs-CZ-Eliska.webp",
				sample: "/voice_samples/ai2-cs-CZ-Eliska.mp3",
			},
		},
		en: {
			female: {
				code: "ai2-Emily",
				languageCode: "en-GB",
				name: "Emily",
				photo: "/faces/en-GB/ai2-Emily.webp",
				sample: "/voice_samples/ai2-Emily.mp3",
			},
			male: {
				code: "ai4-Edward",
				languageCode: "en-US",
				name: "Freddie",
				photo: "/faces/en-US/ai4-Edward.webp",
				sample: "/voice_samples/ai4-Edward.mp3",
			},
		},
	};
	return data[language][gender];
};
